const hubs = [
  "Minneapolis",
  "St Paul",
  "Bloomington",
  "Plymouth",
  "Maple Grove",
  "Brooklyn Park",
  "Eden Prairie",
  "Minnetonka",
  "Woodbury",
  "Lakeville",
  "Burnsville",
  "Eagan",
  "Coon Rapids",
  "Blaine",
  "Apple Valley",
  "Edina",
  "St Louis Park",
  "Shakopee",
  "Richfield",
  "Golden Valley",
  "Roseville"
];

export default hubs;
